import React from "react";
import MediaFilterContext from "app/app/mediaSelector/contexts/MediaFilterContext";

export default function useMediaFilter() {
    return React.useContext(MediaFilterContext);
}
